export default __webpack_public_path__ + "static/media/landing-image.54a3d1a5.jpg";